import 'vuetify/styles'
import './v3-compat.css'
import { createVuetify } from 'vuetify'
import { SELECT_LIST_PROPS } from '@/shared/constants/menuSelect'
import { aliases, mdi } from "vuetify/iconsets/mdi";
import '@mdi/font/css/materialdesignicons.css';
import { CustomTheme } from './theme'
import { fa } from "vuetify/iconsets/fa";
// make sure to also import the coresponding css
import '@fortawesome/fontawesome-free/css/all.css' // Ensure your project is capable of handling css files
import { md } from 'vuetify/iconsets/md'
import 'material-icons/iconfont/material-icons.css'  // Add this for Material Icons

// Every select / autocomplete / combobox list in the profile-menu look (common/MenuListItem.vue): rows 4px apart and
// the chosen row in brand colour. Row shape, text and scrollbar are in base/_global.scss, as many fields draw their
// own rows. A field's own listProps still win.
const DROPDOWN_LIST = {
  listProps: { ...SELECT_LIST_PROPS, color: 'brand-color' },
}

const vuetify = createVuetify({
  // Vuetify 4 lowered the md+ breakpoints; keep v3 values (must match ./settings.scss)
  display: {
    thresholds: {
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
      fa,
      md
    },
  },
  theme: {
    defaultTheme: 'CustomTheme',
    themes: {
      CustomTheme,
    },
  },
  defaults: {
    global: {
      font: {
        family: 'Poppins, sans-serif',
      },
    },
    VBtn: {
      rounded: 'lg',
      variant: 'flat',
      elevation: 0,
      class: 'text-none',
    },
    VChip: {
      rounded: 'lg',
      class: 'font-weight-medium',
    },
    // All checkboxes (table ticks too): brand (primary) when unticked, accent when ticked, 20px box;
    // an explicit color still wins.
    VCheckbox: {
      color: 'accent-color',
      baseColor: 'brand-color',
      VIcon: { size: 20 },
    },
    VCheckboxBtn: {
      color: 'accent-color',
      baseColor: 'brand-color',
      VIcon: { size: 20 },
    },
    // 150ms before closing, so the mouse can cross the gap into an interactive tooltip (its Learn More button);
    // Vuetify 4 closes at once otherwise.
    VTooltip: {
      closeDelay: 150,
    },
    VCard: {
      rounded: 'lg',
      elevation: 0,
      class: 'border-thin',
    },
    VTextField: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VTextarea: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VSelect: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
      ...DROPDOWN_LIST,
    },
    VAutocomplete: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
      ...DROPDOWN_LIST,
    },
    VCombobox: {
      ...DROPDOWN_LIST,
    },
    VSwitch: {
      color: 'accent-color',
      inset: true,
      density: 'compact',
    },
    VAlert: {
      rounded: 'lg',
      density: 'compact'
    },
    VSnackbar: {
      rounded: 'lg',
      density: 'compact',
    },
  },
})

export default vuetify;
